<template>
  <div>
    <opq-basic-appbar>
      <template v-if="ressources.length > 0">
        <ressource code="titre-formulaire"></ressource>
      </template>
      <template v-else>
        <v-skeleton-loader type="text" width="250" height="15"></v-skeleton-loader>
      </template>
    </opq-basic-appbar>
    <v-main>
      <v-sheet class="ml-6 py-4 py-md-8 py-lg-12 px-2 px-md-6 px-lg-12">
        <template v-if="loading">
          <opq-loading />
        </template>
        <template v-else>
          <ressource code="accueil-question-preliminaire"></ressource>
          <v-divider class="my-6"></v-divider>
          <ressource code="question"></ressource>

          <v-card
            v-for="choice in choices"
            :key="choice.code"
            max-width="500"
            class="pa-6 mt-3 question-preliminaire-choix"
            outlined
            @click="redirect(choice)"
          >
            <ressource :code="choice.code"></ressource>
          </v-card>
        </template>
      </v-sheet>
    </v-main>
  </div>
</template>

<script>
import FormulaireBase from "@/mixins/FormulaireBase"
import { isFormulaireDemandeAutorisationSpecialeCoche } from "@/plugins/services/contacts"
import { mapGetters } from "vuex"
import { getContextWithToken } from "@/plugins/services/auth"

export default {
  mixins: [FormulaireBase],
  data() {
    return {
      choices: [
        { code: "regulier", url: "/demande-permis-psychologue-regulier/introduction", type: "REG" },
        { code: "permis-sur-permis", url: "/demande-permis-psychologue-regulier/introduction", type: "PSP" },
        { code: "equivalence", url: "/demande-permis-psychologue-equivalence/introduction" },
        { code: "autorisation-speciale", url: "/demande-permis-psychologue-regulier/introduction", type: "SPE" }
      ]
    }
  },
  async created() {
    await this.loadToken()
    this.loadParams("question-preliminaire-permis-psychologue")
    if (this.loadContact()) {
      // US 18
      isFormulaireDemandeAutorisationSpecialeCoche(this.$route.query.contactId)
        .then((response) => {
          if (response.data.found == false) {
            this.choices.splice(this.choices.indexOf(this.choices.find((c) => c.code == "autorisation-speciale")), 1)
          }
        })
        .catch((err) => {
          this.$router.push({ name: "Unauthorized" })
        })
    }
  },
  computed: {
    ...mapGetters(["ressources"])
  },
  methods: {
    async loadToken() {
      if (this.$route.query.token) {
        const token = this.$route.query.token.replace(/\s/g, "+")
        const encodedToken = encodeURIComponent(token)
        try {
          let result = await getContextWithToken(encodedToken)
          if (result.data.success) {
            const contactId = result.data.contactId
            this.$router.replace({ path: this.url, query: { contactId } })
          } else {
            throw "Unauthorized"
          }
        } catch (error) {
          this.$router.push({ name: "Unauthorized" })
        }
      }
    },
    loadContact() {
      if (this.$route.query.contactId || this.$route.query.token) {
        return true
      } else {
        this.$router.push({ name: "NoContactId" })
        return false
      }
    },
    redirect(choice) {
      this.$router.push({ path: choice.url, query: { ...this.$route.query, ...(choice.type ? { type: choice.type } : null) } })
    }
  }
}
</script>

<style>
</style>